module.exports = __webpack_public_path__ + "static/img/lihong.41de3de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teacher/lihong.png
// module id = 6d9Y
// module chunks = 2